export const PERKS_SIGNUP_RESULT_KEY = 'perks-signup-result-key';
export const PERKS_REDIRECT_URL_KEY = 'perks-redirect-url-key';
export const PERKS_WAS_COLLECTION_REDIRECTED_KEY = 'perks-was-collection-redirected-key';

export const PERKS_SIGNUP_ERROR_KEY = 'perks-signup-error-key';
export const PERKS_RESPONSE_SEEN_ON_PF_KEY = 'perks-response-seen-on-pf';

export const NEW_MEMBER_SIGNUP = 'newMemberSignup';

export const PREVIOUS_MEMBER_SIGNUP = 'existingMemberSignup';
